'use strict';

angular.module('docketbook')
.controller('companySettingsResourceCategoriesController', function(resourceService, $q, $scope, $window, Restangular, $state, $stateParams, accessControl) {
  mixpanel.track("Opened CompanySettings-ResourceCategories Desktop");

  $scope.currentUser = accessControl.currentUser();
  $scope.currentState = $state.current;
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();

  $scope.selected = [];
  $scope.query = {
    limit: 10,
    page: 1,
    order: 'name'
  };
  $scope.listCount = 0;

  $scope.loadCategoriesList = function() {
    $scope.promise = $q(function(resolve, reject) {
      var queryParams = {};
      queryParams.limit = $scope.query.limit;
      queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
      queryParams.sort = $scope.query.order;
      resourceService.getResourceCategories(queryParams, function(categories) {
        $scope.allResourceCategories = categories;
        if ( queryParams.offset <= 0 && categories.length < queryParams.limit ) {
          $scope.listCount = categories.length;
        } else {
          $scope.listCount = queryParams.offset + (queryParams.limit + 1);
        }
        resolve('Done');
      }, function(err) {
        $scope.allResourceCategories = [];
        reject('Error');
      });
    });
  }

  $scope.loadCategoriesList();

  $scope.goTo = function(href) {
    $window.location.href = href;
  }

  $scope.openMenu = function($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  /************************************/
  /***** Resource Categories Func *****/
  /************************************/

  // Create a new resource type modal
  $scope.openNewResourceCategoryModal = function() {
    $scope.itemEdit = {};
    $("#newResourceCategoryModal").fadeIn(100);
  }

  // Close new resource modal
  $scope.closeNewResourceCategoryModal = function() {
    $("#newResourceCategoryModal").fadeOut(100, function() {
      $scope.itemEdit = {};
    });
  }

  $scope.editResourceCategory = function(item) {
    $scope.itemEdit = item;
    item.loading = false;
    $("#newResourceCategoryModal").fadeIn(100);
  }

  var refreshResourceCategories = function() {
    $scope.loadCategoriesList();
  }

  // Save a new resource cat for the organisation
  $scope.saveNewResourceCategory = function(category) {
    category.loading = true;
    resourceService.saveResourceCategory(category, function(updatedCategory) {
      $("#newResourceCategoryModal").fadeOut(100);
      $scope.loadCategoriesList();
    }, function(err) {
      category.loading = false;
      $scope.alertService.presentAutoAlert('saveResourceCategory', err);
    });
  }

  $scope.deleteSelectedCategories = function() {
    var count = $scope.selected.length;
    swal({
			title: "Are you sure?",
			text: count + " categories will be deleted.",
			type: "warning",
			showCancelButton: true,
			confirmButtonColor: "#DD6B55",
			confirmButtonText: "Yes, delete it!",
			cancelButtonText: "No, cancel!",
			closeOnConfirm: true,
			closeOnCancel: true
		}, function(isConfirm){
			if (isConfirm) {
        resourceService.deleteBulkResourceCategories($scope.selected, function(failures) {
          if ( failures && failures.length > 0 ) {
            $scope.alertService.presentAutoAlert('deleteBulkResourceCategories', {status:202, requestName: 'Delete bulk resource categories - failures ' + failures.length + ' of ' + $scope.selected.length});
            $scope.loadCategoriesList();
          } else {
            $scope.alertService.presentAutoAlert('deleteBulkResourceCategories',{status:200});
            $scope.loadCategoriesList();
          }
        });
      }
    });
  }

});



// WEBPACK FOOTER //
// ./src/controllers/companySettings/resourceCategories.js